"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _highchartsReactOfficial = _interopRequireDefault(require("highcharts-react-official"));

var _utils = require("./utils");

var _utils2 = require("../../../utils");

require("./ColumnChart.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function ColumnChart(props) {
  var data = props.data,
      labels = props.labels,
      isSelected = props.isSelected,
      labelFormat = props.labelFormat,
      min = props.min,
      max = props.max,
      className = props.className,
      showPercentage = props.showPercentage;
  return /*#__PURE__*/_react.default.createElement(_highchartsReactOfficial.default, {
    containerProps: {
      className: (0, _utils2.getClassNames)('Highcharts-column-chart', className)
    },
    options: (0, _utils.getColumnChartOptions)(data, labels, isSelected, labelFormat, min, max, showPercentage)
  });
}

ColumnChart.propTypes = {
  /** Data to be shown on chart */
  data: _propTypes.default.arrayOf(_propTypes.default.shape({
    name: _propTypes.default.string,
    data: _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape(_defineProperty({}, _propTypes.default.string, _propTypes.default.number)), _propTypes.default.arrayOf(_propTypes.default.number)])).isRequired
  })),

  /** Labels to be shown on X axis */
  labels: _propTypes.default.arrayOf(_propTypes.default.string),

  /** Index of value with shown labels */
  isSelected: _propTypes.default.number,

  /** Formats of X axis label */
  labelFormat: _propTypes.default.func,

  /** Max value of Y axis */
  max: _propTypes.default.number,

  /** Min value of Y axis */
  min: _propTypes.default.number,

  /** Whether to show values by each column */
  showPercentage: _propTypes.default.bool,
  className: _propTypes.default.string
};
ColumnChart.defaultProps = {
  min: undefined,
  max: undefined,
  data: [],
  labels: [],
  isSelected: undefined,
  showPercentage: false,
  labelFormat: function labelFormat(label) {
    return label;
  },
  className: ''
};
var _default = ColumnChart;
exports.default = _default;